import { render } from "./Profile.vue?vue&type=template&id=77bb481d"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=77bb481d&lang=css"
script.render = render

export default script